import * as moment from "moment-timezone";
import {NavAvatar} from "../../nav/NavAvatar";
import * as React from "react";
import './Comment.pcss';
import {CommentReplies} from "./CommentReplies";
import {CommentDataInterface} from "data/FullPostModalData";
import {Ago} from "./Ago";
import {IMentionUser} from "shared/IMentionUser";
import {INotification, NotificationTypeHelper} from "data/entities/INotification";
import {ReplyIcon} from "components/widgets/icons/ReplyIcon";
import {MentionIcon} from "components/widgets/icons/MentionIcon";
import {stripHtml} from "utils";

interface Props {
  comment:any;
  addReply:(commentData:CommentDataInterface)=>Promise<void>;
  commentPeriodHasEnded:boolean;
  possibleUsersToMention:IMentionUser[];
  possibleRelatedNotifications:INotification[];
}


export const Comment = (props:Props) => {

  let nameOrNickname = ''; props.comment.userId ? props.comment.userId.nameOrNickname : '';
  let isPractitioner = false;
  if(props.comment.userId) {
    // console.log(props.comment.userId);
    nameOrNickname = props.comment.userId.nameOrNickname;
    isPractitioner = !!props.comment.userId.isDietitian || !!props.comment.userId.isVendorBoothHost;
  }

  const comment = (props.comment.comment||"").replace(/@\[(.+?)\]\((.+?)\)/g, (match, name, id) => {
    return `<span class="mention" data-user-id="${id}">${name.trim()}</span>`;
  });

  let relatedToNotification:INotification|null = null;
  if(props.possibleRelatedNotifications) {
    for(let possibleRelatedNotification of props.possibleRelatedNotifications) {
      if(possibleRelatedNotification.referencedEntityId==props.comment._id) {
        relatedToNotification = possibleRelatedNotification;
        break;
      }
    }
  }

  const commentMoment = moment(props.comment.dateCreated);
  const srCommentLabel = `Comment from ${nameOrNickname}`;
  const ago = new Ago(commentMoment);
  const srComment = `${ago.readable}, ${nameOrNickname} said ${stripHtml( comment )}${props.comment.photo?' There is a photo associated with this comment.':''}`;

  return (
    <>
      <div className={`comment ${relatedToNotification?'related-to-notification':''}`} role={'list-item'} aria-label={srCommentLabel}>
        <span className={'visuallyhidden'}>{srComment}</span>
        <div className={"comment-avatar"} aria-hidden>
          <NavAvatar user={props.comment.userId} variant={'small'} />
        </div>
        <div className={"comment-body"} aria-hidden>

          <h4 className={`cb-name-and-date${isPractitioner?' verified':''}`}>
            <span aria-hidden>
              {isPractitioner && <span className="material-icons verified" aria-hidden="true">verified</span>}
              <strong>{nameOrNickname}</strong>
              <span className={"ago"}>{ago.visible}</span>
            </span>
          </h4>
          <p className="cb-text" dangerouslySetInnerHTML={{ __html:comment}} />
          {props.comment.photo && <img src={`usercontent/${props.comment.photo}`}/> }

          {relatedToNotification && <>
            <div  aria-hidden className={"notification-indicator-bell"}>{relatedToNotification.type==NotificationTypeHelper.notificationTypes.MENTION.type ? <MentionIcon /> : <ReplyIcon />}</div>
            <div  aria-hidden className={"notification-indicator"}></div>
          </>
          }

        </div>

      </div>
      <CommentReplies
        comment={props.comment}
        addReply={props.addReply}
        commentPeriodHasEnded={props.commentPeriodHasEnded}
        possibleUsersToMention={props.possibleUsersToMention}
        possibleRelatedNotifications={props.possibleRelatedNotifications}
      />
    </>
  );

}

